import styled from 'styled-components';

const DescriptionStyle = styled.div`
	--infoMarginT: var(--sp6x);
	--descMarginT: var(--sp4x);
	--shareMarginT: var(--sp7x);
	--imgMarginB: var(--sp10x);
	--borderRadius: var(--sp4x);
	--imageSize: 39.3%;

	color: var(--green1000);

	.wrapper-subtitle {
		margin-top: var(--infoMarginT);
	}

	.wrapper-information {
		margin-top: var(--infoMarginT);

		&:first-child {
			margin-top: unset;
		}
	}

	.wrapper-desc {
		margin-top: var(--descMarginT);
	}

	.image-wrapper {
		margin-top: var(--infoMarginT);

		.image-cont {
			--proportion: var(--imageSize);

			img {
				border-radius: var(--borderRadius);
			}
		}
	}

	.wrapper-shared {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: var(--shareMarginT);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--descMarginT: var(--sp3x);
		--infoMarginT: var(--sp5x);
		--shareMarginT: var(--sp5x);
		--borderRadius: var(--sp3x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--infoMarginT: var(--sp4x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--infoMarginT: var(--sp3x);
		--descMarginT: var(--sp2x);
		--borderRadius: var(--sp2x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--shareMarginT: var(--sp4x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--descMarginT: var(--sp2x);
		--descMarginT: var(--sp1-5x);
		--shareMarginT: var(--sp3x);
		--borderRadius: var(--sp1-5x);
		--imageSize: 49.7%;
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--infoMarginT: var(--sp3x);
	}
`;
export default DescriptionStyle;
